<template>
  <div>
    <div id="map" />
    <MapUI @zoom="handleMapNav"/>
    <!-- <MapFilterBox @filter="handleFilter" :showLayers="showLayers" /> -->
  </div>
</template>

<script>
import _Mapbox from '@/plugins/mapbox';
import MapUI from '@/components/views/map/MapUI';
// import MapFilterBox from '@/components/views/map/MapFilterLayers';
import _kebabCase from 'lodash.kebabcase';

import { mapGetters } from 'vuex';

export default {
  name: 'Map',
  components: {
    MapUI,
    // MapFilterBox
  },
  data() {
    return {
      map: null,
      layerConfig: [
        { country: 'Vietnam', city: 'Hanoi', filter: 'energy-housing-mobility'},
        { country: 'Vietnam', city: 'Can Tho', filter: 'housing-mobility-water'},
        { country: 'Indonesia', city: 'Jakarta', filter: 'energy-housing-mobility' },
        { country: 'India', city: 'Bengaluru', filter: 'mobility'},
        { country: 'India', city: 'Delhi', filter: 'energy-housing-waste'},
        { country: 'India', city: 'Mumbai', filter: 'energy-housing-water' },
        { country: 'Thailand', city: 'Bangkok', filter: 'energy-housing-waste' },
        { country: 'Thailand', city: 'Lamphun', filter: 'energy-housing' },
        { country: 'Thailand', city: 'Prik', filter: 'water-waste' },
        { country: 'Philippines', city: 'Iloilo City', filter: 'energy-housing' },
        { country: 'Philippines', city: 'Cebu City', filter: 'energy-housing'},
        { country: 'South Korea', city: 'Seoul', filter: 'housing-mobility' }
      ],
      showLayers: false
    }
  },
  computed: {
    defaultOptions() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return {
          container: 'map',
          style: 'mapbox://styles/fesasia/ckurvg7jx1pk219o388688re5',
          center: [91.059, 20.9],
          zoom: 3,          
        };
      } else if (this.$vuetify.breakpoint.xlOnly) {
        return {
          container: 'map',
          style: 'mapbox://styles/fesasia/ckurvg7jx1pk219o388688re5',
          center: [97.007287, 19.289635],
          zoom: 3.2,          
        };
      }
      return {
        container: 'map',
        style: 'mapbox://styles/fesasia/ckurvg7jx1pk219o388688re5',
        center: [97.007287, 19.289635],
        zoom: 3.2,
      };
    },
     ...mapGetters('contentPanel', ['panelState', 'mapInteractive']), 
  },
  watch: {
    panelState(newVal) {
      if (newVal === '') {
        this.resetMap();
      }
    }, 
    mapInteractive(newVal) {
      this.toggleMapInteractive(newVal);
      this.resetMap();
    },
  },
  async mounted() {
    // init Mapbox
    this.map = _Mapbox.createMap(this.defaultOptions);

    // basic map interaction setting 
    this.map.touchZoomRotate.disableRotation();
    this.map.touchPitch.disable();

    await this.map.on('load', () => {
      this.loadCities();
    }); 
  },
  methods: {
    toggleMapInteractive(state) {
      if (state) {
        this.map.boxZoom.enable();
        this.map.scrollZoom.disable();
        this.map.dragPan.enable();
        this.map.dragRotate.enable();
        this.map.doubleClickZoom.enable();
        this.map.touchZoomRotate.enable();

        // enable grab cursor
        const mapCanvas = document.querySelector('.mapboxgl-canvas-container');
        mapCanvas.classList.toggle('mapboxgl-interactive');
      }
    },
    loadCities() {
      this.map.addSource('fes-cities', {
        type: 'geojson',
        data: `${process.env.BASE_URL}data/fes-map.json`,
      });

      const map = this.map;

      this.layerConfig.forEach(layer => {
        this.map.loadImage(`${process.env.BASE_URL}data/icons-map/${_kebabCase(layer.city)}-icon.png`, 
          function(error, image) {
            if (error) throw error;
            map.addImage(layer.city, image);

            map.addLayer({
              id: `${_kebabCase(layer.city)}--${layer.filter}`,
              type: 'symbol',
              source: 'fes-cities',
              layout: {
                'icon-image': 
                  ['get', 'city'],            
                'icon-size': [
                  'interpolate', 
                  ['linear'], ['zoom'], 
                  3, 0.14,
                  9, 0.225,  
                ], 
                'icon-allow-overlap': true,     
                'icon-ignore-placement': true,                       
              },
              filter: ['==', 'city', layer.city]
            });       
          }
        );        
      })

      this.handleInteractivity();
    },
    handleFilterByCountry(selected) {
      const selectedLayers = selected.map(n => _kebabCase(n));
      const allMapLayers = this.layerConfig.map(layer => `${_kebabCase(layer.country)}-${_kebabCase(layer.city)}`);

      allMapLayers.forEach(layer => {
        const layerCountry = layer.split('-')[0];
        this.map.setLayoutProperty(layer, 'visibility', selectedLayers.indexOf(layerCountry) !== -1 ? 'visible' : 'none');
      });
    },     
    handleFilter(selected) {
      const selectedLayers = selected.map(n => _kebabCase(n));
      const allMapLayers = this.layerConfig.map(layer => `${_kebabCase(layer.city)}--${layer.filter}`);

      allMapLayers.forEach(layer => {
        this.map.setLayoutProperty(layer, 'visibility',  checkArray(selectedLayers, layer) ? 'visible' : 'none');
      });

      function checkArray(selectedLayers, mapLayer) {
        const map = mapLayer.split("--")[1];
        const mapArray = map.split("-");

        return selectedLayers.some(item => mapArray.includes(item))
      }
    },         
    handleInteractivity() {
      this.popUp = _Mapbox.createPopup({ closeButton: false, anchor: 'bottom', className: 'tooltip-city text--fes-blue' });

      this.layerConfig.forEach(layer => {
        this.map.on('click', `${_kebabCase(layer.city)}--${layer.filter}`, e => {
          const coord = e.features[0].geometry.coordinates;       

          // map action
          // this.map.getZoom() < 11.5 ? 
          // this.map.flyTo({ center: [coord[0] - 0.2, coord[1]], zoom: 10}) :
          // this.map.flyTo({ center: [coord[0], coord[1]], zoom: this.map.getZoom()});  

          // map action
          this.map.flyTo(this.$vuetify.breakpoint.mdAndUp ? {center: [coord[0] - 0.2, coord[1]], zoom: 10} : {center: [coord[0], coord[1] - 0.05], zoom: 10}
          )  

          // data action
          this.$store.dispatch('contentPanel/updatePanelState', '--is-open');
          this.$store.dispatch('contentPanel/updatePanelContent', e.features[0].properties);
        });

        if (this.$vuetify.breakpoint.lgAndUp) {
          this.map.on('mouseenter', `${_kebabCase(layer.city)}--${layer.filter}`, this.handleMapPopup);          
          this.map.on('mouseleave', `${_kebabCase(layer.city)}--${layer.filter}`, this.handleLayerExit);
        }
      });
    },
    handleMapPopup(e) {      
      this.map.getCanvas().style.cursor = 'pointer';
      const coordinates = e.features[0].geometry.coordinates.slice();
      const cityName = e.features[0].properties.city;
      this.popUp
        .setLngLat(coordinates)
        .setHTML(`<p class="text-nav-anchor mb-0">${cityName}</p>`)
        .addTo(this.map);
    },     
    handleLayerExit() {
      this.map.getCanvas().style.cursor = '';
      this.popUp.remove();

      // const popUp = this.popUp;
      // setTimeout(function(){
      //   popUp.remove();
      // }, 5000);    
    },
    handleMapNav($event) {
      if ($event === 'in') {
        this.map.zoomIn();
      } else if ($event === 'out') {
        this.map.zoomOut();
      } else if ($event === 'filter') {
        this.showLayers = !this.showLayers;
      } else if ($event === 'reset') {
        this.resetMap();
      }
    },
    resetMap() {
      this.map.getZoom() !== 2.5 ? 
      this.map.flyTo({ center: [97.007287, 19.289635], zoom: this.$vuetify.breakpoint.lgAndDown ? 3.2 : 3.5}) : '';
            // close panel when user reset the map
      this.$store.dispatch('contentPanel/updatePanelState', '');
    },
  }
};
</script>

<style lang="scss" scoped>
@import '~mapbox-gl/dist/mapbox-gl.css';

#map {
  width: 100%;
  height: 100%;
  position: relative;
  
  .tooltip-city {
    background: rgba(250, 250, 250, 0.9);
    backdrop-filter: blur(10px);
    padding: 12px;
    border-radius: unset !important;    
    transition: opacity 1s;
    opacity: .1;    
  }
}
</style>


  